<template>
  <div class="grid-box">
    <!-- 投标模块 -->
    <div>
      <!-- 头标展示区 -->
      <van-grid square :column-num="4" :border="false" icon-size="1rem">
        <van-grid-item
          v-for="(item,index) in menuData"
          :key="index"
          :icon="item.file_url"
          :text="item.menu_name"
          :url="item.menu_href"
          :badge="item.count"
        />
      </van-grid>
      <!-- 头标展示区结束 -->
    </div>
    <!-- 投标模块结束 -->
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    menuList: {
      type: Array
    }
  },
  watch: {
    menuList(val) {
      this.menuData = val; //给展示的list赋值
    }
  },
  data() {
    return {
      menuData: [], //接收父组件传递过来的menu数据
      itemMore: [
        {
          file_url: require("../../../assets/images/more.png"),
          menu_name: "更多",
          menu_href: "/serviceHall"
        }
      ], //更多按钮

      // birthdayList:[
      //   {
      //     file_url: require("../../../assets/images/more.png"),
      //     menu_name: "生日慰问",
      //     menu_href: "/birthdayWel"
      //   }
      // ]
      
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化函数
    init() {
      this.gianListData();
    },
    // 给展示的list赋值
    gianListData() {
      this.menuData = this.menuList;
      this.menuData = [...this.menuData, ...this.itemMore];
      console.log('menuList',this.menuData);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../../assets/stylus/index.styl';
@import '../../../assets/stylus/reset.css';

.grid-box {
  margin-top: 10px;
  background: #fff;
  padding-bottom: 10px;
  >>>.van-info {
    top: 6px;
  }
}

.grid-title {
  color: #353535;
  font-size: 17px;
  padding: 0px 15px 0;
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 24px;
}
</style>